module.exports = __webpack_public_path__ + "public/media/misr el-ghad.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/misr el-ghad.png
// module id = ./images/partners/misr el-ghad.png
// module chunks = 0